import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useSupplier(id: string | undefined) {
  return useQuery({
    ...orpc.accountsPayable.suppliers.get.queryOptions({
      input: id ? { id } : skipToken,
    }),
    enabled: Boolean(id),
  });
}
